import React from 'react';
import { Container } from '../Components/ui/container';
import { Inline } from '../Components/ui/layout';
import { Input } from '../Components/ui/input';
import { Button } from '../Components/ui/button';

const SearchBar = () => {
  return (
    <section className="py-lg bg-background border-b border-border">
      <Container>
        <form>
          <Inline spacing="sm" className="flex-col md:flex-row w-full gap-md">
            <div className="relative flex-1 w-full">
              <img 
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/971adf7b59ada0d23a815905015e5499e4178603990d8f27ec9420fad75de37a?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f" 
                alt="Search" 
                className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 opacity-50" 
              />
              <Input
                type="text"
                placeholder="Title, skill or company"
                className="pl-10 w-full"
                aria-label="Search for title, skill or company"
              />
            </div>
            <div className="relative flex-1 w-full">
              <img 
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/971adf7b59ada0d23a815905015e5499e4178603990d8f27ec9420fad75de37a?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f" 
                alt="Location" 
                className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 opacity-50" 
              />
              <Input
                type="text"
                placeholder="City, state or zip code"
                className="pl-10 w-full"
                aria-label="Enter city, state or zip code"
              />
            </div>
            <Button type="submit" variant="default" size="lg" className="w-full md:w-auto">
              Search
            </Button>
          </Inline>
        </form>
      </Container>
    </section>
  );
};

export default SearchBar;